export enum PropertyAttachmentsTypes {
  PDF = 'PDF',
  IMG = 'IMG',
  FLOOR_PLAN = 'FLOOR_PLAN'
}
